import script from "./SkeletonLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkeletonLine.vue?vue&type=script&setup=true&lang=ts"

import "./SkeletonLine.vue?vue&type=style&index=0&id=1cf3137c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf3137c"]])

export default __exports__